import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'axios'; // Not using helpers/api since we need page_options.options to be snake_cased
import { put } from 'helpers/api';
import Option from '../document_defaults/option_defaults/option';
import { Button } from 'components/ui/button';
import { Errors } from 'components/ui/errors';
import { showRequestFailure, showSnackbar } from 'components/ui/snackbar/helper';

export default function InvoiceDefaults({ pageOptionsPath }) {
  const [options, setOptions] = useState([]);
  const [pageOption, setPageOption] = useState({});
  const [saving, setSaving] = useState(false);
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    // If the defaults can't load, the form is empty and the server refuses its Save; say why instead.
    async function fetchData() {
      try {
        const pageOptionsData = await get(pageOptionsPath);
        setOptions(pageOptionsData.data.all_options);
        setPageOption(pageOptionsData.data.page_options);
      } catch {
        setLoadFailed(true);
      }
    }

    fetchData();
  }, []);

  function updateOption(changes) {
    setPageOption({ ...pageOption, options: { ...pageOption.options, ...changes } });
  }

  function handleRemoveOptions(names) {
    const updatedOptions = Object.keys(pageOption.options).reduce((accumulator, key) => {
      if (!names.includes(key)) accumulator[key] = pageOption.options[key];
      return accumulator;
    }, {});

    setPageOption({ ...pageOption, options: updatedOptions });
  }

  async function saveDefaults() {
    setSaving(true);

    try {
      await put(pageOptionsPath, {
        unscope: false,
        pageDefaults: {
          pageName: pageOption.pageName,
          pageTemplateUserLabel: pageOption.pageTemplateUserLabel,
          options: pageOption.options,
          pageTemplateStyleId: pageOption.pageTemplateStyleId
        }
      });
    } catch (error) {
      showRequestFailure(error, 'The defaults could not be saved. Please try again.');
      return;
    } finally {
      setSaving(false);
    }

    showSnackbar({ text: 'Changes successfully saved', variant: 'success' });
  }

  return (
    <React.Fragment>
      <div className="form-horizontal">
        <div className="mb-4 d-flex justify-content-between align-items-center">
          <h5>Invoice Defaults</h5>
          <Button disabled={saving || loadFailed} label="Save Defaults" onClick={saveDefaults} />
        </div>
        {loadFailed && (
          <Errors error="The invoice defaults could not be loaded. Please reload the page." title={false} />
        )}
        {options.map((option, i) => (
          <div className={i < options.length - 1 ? 'mb-3' : ''} key={option.name}>
            <Option
              defaults={pageOption.options || {}}
              option={option}
              onRemove={handleRemoveOptions}
              onUpdate={updateOption}
            />
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

InvoiceDefaults.propTypes = {
  pageOptionsPath: PropTypes.string.isRequired
};
